<template>
  <div class="states-form">
    <div v-for="(headerChoice, index) in headerChoices" :key="index" class="element">
      <div :class="{ active: headerChoice.active }" class="title cursor-pointer" @click="goToNav(headerChoice)">
        <i :class="headerChoice.icon" class="bx-sm"> </i>
        <p>
          {{ headerChoice.title }}
        </p>
      </div>
      <div
        v-if="index !== headerChoices.length - 1"
        class="line"
        :style="'width:' + lineWidth / headerChoices.length + 'px'"
      >
        <span></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'states',

  props: {
    headerChoices: {
      type: Array,
      required: true,
    },
    routeActive: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      screenSize: {
        width: null,
        height: null,
      },
      lineWidth: 500,
    }
  },

  beforeMount() {
    window.addEventListener('resize', this.screenSizeFunction, true)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.screenSizeFunction, true)
  },
  mounted() {
    this.screenSizeFunction()
  },

  methods: {
    screenSizeFunction() {
      this.screenSize.width = window.innerWidth
      this.screenSize.height = window.innerHeight
      this.setLineWidthValue()
    },

    setLineWidthValue() {
      if (this.screenSize.width < 1450) {
        this.lineWidth = 200
      } else {
        this.lineWidth = 500
      }
    },

    goToNav(navChoice) {
      if (this.routeActive && !navChoice.active) {
        this.$router.replace({ name: navChoice.routeName })
      }
    },
  },
}
</script>

<style scoped></style>
